<!-- Hero Section -->
<section id="hero">
  <app-hero-app></app-hero-app>
</section>

<!-- Product Apps Grid -->
<app-product-app></app-product-app>
